/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { RenderConditionFromJSON, RenderConditionToJSON } from './RenderCondition';
import { CreateBlockFromJSON, CreateBlockToJSON } from './CreateBlock';
import { ResourceAuthorizationRuleFromJSON, ResourceAuthorizationRuleToJSON } from './ResourceAuthorizationRule';

/**
 * An instance of a zone that has been persisted into the system.
 * @export
 * @interface Zone
 */

/**
 * Check if a given object implements the Zone interface.
 */
export function instanceOfZone(value) {
  return true;
}
export function ZoneFromJSON(json) {
  return ZoneFromJSONTyped(json, false);
}
export function ZoneFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'zoneRID': json['zoneRID'] == null ? undefined : json['zoneRID'],
    'id': json['id'] == null ? undefined : json['id'],
    'zoneType': json['zoneType'] == null ? undefined : json['zoneType'],
    'zoneParameters': json['zoneParameters'] == null ? undefined : json['zoneParameters'],
    'blocks': json['blocks'] == null ? undefined : json['blocks'].map(CreateBlockFromJSON),
    'condition': json['condition'] == null ? undefined : RenderConditionFromJSON(json['condition']),
    'foreach': json['foreach'] == null ? undefined : json['foreach'],
    'as': json['as'] == null ? undefined : json['as'],
    'authorize': json['authorize'] == null ? undefined : json['authorize'].map(ResourceAuthorizationRuleFromJSON)
  };
}
export function ZoneToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'zoneRID': value['zoneRID'],
    'id': value['id'],
    'zoneType': value['zoneType'],
    'zoneParameters': value['zoneParameters'],
    'blocks': value['blocks'] == null ? undefined : value['blocks'].map(CreateBlockToJSON),
    'condition': RenderConditionToJSON(value['condition']),
    'foreach': value['foreach'],
    'as': value['as'],
    'authorize': value['authorize'] == null ? undefined : value['authorize'].map(ResourceAuthorizationRuleToJSON)
  };
}